import { createBrowserRouter } from "react-router-dom";
import Dashboard from "../Layouts/Dashboard";
import Home from "../Pages/Home";
import Weather from "../Pages/Weather";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Dashboard />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "/weather",
                element: <Weather />,
            },
        ],
    },
]);

export default router;
